module.exports = __webpack_public_path__ + "static/media/home-card-03.91bb4746.png";